import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon, FontAwesomeLayersText, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'
import { faGithub, faInstagram, faVk, faTelegram } from '@fortawesome/free-brands-svg-icons'

library.add(
  faGithub,
  faInstagram,
  faVk,
  faTelegram
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)

Vue.config.productionTip = false

Vue.use(VueRouter)

const routes = [
  { path: '/', component: App },
  { path: '*', component: App }
]

const router = new VueRouter({
  // mode: 'history',
  base: '/c',
  routes: routes // сокращённая запись для `routes: routes`
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
